/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-18 14:10:29
 * @Description: file content
 */
/* eslint-disable no-control-regex */
/* eslint-disable react/jsx-wrap-multilines */
//  这个组件需要根据原始需求重构  TODO  bbqin
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Dropdown from '../Dropdown';
import NCFormControl from '../-FormControl';
import NCHotKeys from '../HotKeys';
import MultiOption from './MultiOption';
import { getSysFieldid, isArrowKeyDown, localeLang, toast, getMultiLang } from '@platform/api';

require('./index.less');

export default class MultiLangText extends Component {
    _currentValue = {};

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            list: [],
            currentValue: '',
            currentIndex: 0,
            json: {},
        };
        this.firstFlag = true;
        this.focused = false;
    }

    UNSAFE_componentWillMount() {
        getMultiLang({
            moduleId: 'base_text_check',
            callback: json => {
                this.setState({ json });
            },
        });
        this.getList();
    }

    componentDidUpdate() {
        if (
            Object.keys(this._currentValue).length !== Object.keys(this.props.value).length ||
            Object.keys(this.props.value).some(key => {
                return (
                    (this._currentValue?.[key]?.value || '') !== (this.props.value[key]?.value || '')
                );
            })
        ) {
            this.getList();
        }
    }

    getList = () => {
        const { languageMeta = [], attrcode, value = {}, LangIndex, onChange } = this.props;
        let { currentIndex } = this.state;
        let list = languageMeta.map((e, i) => {
            e = { ...e };
            //如果设置了显示语种LangIndex 就优先显示
            if (this.firstFlag && LangIndex && e.index === LangIndex) {
                currentIndex = i;
            }
            //如果没有设置 需要显示的语种就显示登录语种
            if (this.firstFlag && !LangIndex && e.languageCode === localeLang) {
                currentIndex = i;
            }
            // e.key = e.index == 1 ? attrcode : attrcode + e.index;
            e.key = attrcode + e.index;
            e.value = (value[e.key] || {}).value || '';

            if (e.index == 0 || e.index == 1) {
                this.mainKey = e.key;
                this.mainIndex = e.index;
            }

            return e;
        });
        // 登录语言无值 主语言有值 展示主语言框
        if (list[currentIndex].value == '' && value[attrcode] && value[attrcode].value) {
            list.map((e, index) => {
                if (!e.index) {
                    currentIndex = index;
                }
            });
        }
        // NCC-225905 登录语言无值 主语言有值 把主语言的值赋给登陆语言
        if (list[currentIndex].languageCode === localeLang && list[currentIndex].value == '' && value[this.mainKey]?.value && !this.focused) {
            // 判断下不是聚焦状态下，删除数据  清空操作
            list[currentIndex].value = value[this.mainKey]?.value;
            // 把主语言的值赋给登陆语言以后把数据同步到表单表格
            let obj = {};
            list.forEach((e, i) => {
                obj[e.key] = {
                    value: e.value,
                    index: e.index,
                    current: currentIndex == i,
                };
            });
            typeof onChange === 'function' && onChange(obj);
        }
        this._currentValue = JSON.parse(JSON.stringify(this.props.value));
        this.setState({
            list,
            currentIndex,
            currentValue: list[currentIndex].value,
        });
    };

    close = () => {
        let { list, currentIndex, currentValue } = this.state;
        const { onBlur, attrcode, onChange, trim = false } = this.props;

        list[currentIndex].value = currentValue;
        // 登陆语言的值赋给主语言
        let localeLangValue = list.find(i => i.languageCode == localeLang);
        let obj = {};
        list.forEach(item => {
            if (item.key == attrcode) {
                if (!item.value && localeLangValue && localeLangValue.value) {
                    item.value = localeLangValue.value;
                }
            }
            obj[item.key] = { value: item.value };
        });

        let needTrim = list.some(item => item.value.startsWith(' ') || item.value.endsWith(' '));
        let changeCurrentValue = currentValue;
        if (trim && needTrim) {
            list.forEach((e, i) => {
                obj[e.key] = {
                    value: e.value?.trim(),
                    index: e.index,
                    current: currentIndex == i,
                };
                if (currentIndex == i) {
                    changeCurrentValue = e.value?.trim();
                }
                e.value = e.value?.trim();
            });
        }

        this.focused = false;

        this.setState({
            currentValue: changeCurrentValue,
            show: false,
            list,
        }, () => {
            trim && needTrim && typeof onChange === 'function' && onChange(obj);
            typeof onBlur === 'function' && onBlur(obj, list[currentIndex].index);
        });
    };

    render() {
        let { show, list, currentIndex, currentValue, json } = this.state;
        const {
            onChange,
            onBlur,
            onSelect,
            disabled,
            placeholder,
            autoFocus,
            maxLength,
            maxlength,
            onFocus,
            attrcode,
            fieldid,
            hotKeyWithArrow,
            getPopupContainer = () => document.body,
            afterContent, // 自定义content右侧内容 ()=>{}
            className,
            id,
            toastContainer,
            value = {},
            regMessage,
        } = this.props;

        let max_l = [maxLength, maxlength].find(e => e || e === 0);
        max_l === undefined && (max_l = Infinity);
        let multiLangClass = classnames({
            'multi-lang-text multi-lang-text-focus': show,
            'multi-lang-text': !show,
        });
        let dropdownClassName = 'multi-lang-text-collapse';
        let hasFieldid = getSysFieldid(fieldid);
        if (hasFieldid && (fieldid || attrcode)) {
            dropdownClassName = dropdownClassName + ` fieldid_${fieldid || attrcode}_select`;
        }
        return (
            <Dropdown
                trigger={['click']}
                overlayClassName={dropdownClassName}
                placement="bottomLeft"
                visible={show}
                getPopupContainer={getPopupContainer} //底层组件这个不能写死，需要的话往下传
                overlay={
                    <ul
                        ref={dom => {
                            this.dropDown = ReactDOM.findDOMNode(dom);
                        }}
                        onMouseDown={e => {
                            e.preventDefault();
                        }}
                        style={{
                            // width: this.multiLangText && this.multiLangText.clientWidth
                        }}
                    >
                        {list.map(({ languageType, value, key }, i) => (
                            <li
                                key={key}
                                className={`multi-lang-text-item  ${currentIndex === i ? 'selected' : ''}`}
                                onClick={e => {
                                    e.stopPropagation();
                                    currentIndex = i;
                                    currentValue = value;
                                    if (list[currentIndex].key == attrcode) {
                                        this.mainIsEmpty = false;
                                    }
                                    this.firstFlag = false;
                                    this.setState(
                                        {
                                            currentValue,
                                            currentIndex,
                                            // show: false
                                        },
                                        () => {
                                            let obj = {};
                                            let loginIndex;
                                            list.forEach((e, i) => {
                                                if (e.languageCode == localeLang) {
                                                    // 当前编辑的是登录语言且主语言没值
                                                    loginIndex = i;
                                                }

                                                obj[e.key] = {
                                                    value: e.value,
                                                    index: e.index,
                                                    current: currentIndex == i,
                                                };
                                            });

                                            if (currentIndex == loginIndex && this.mainIsEmpty) {
                                                // 当前编辑的是登录语言且主语言没值
                                                obj[this.mainKey] = {
                                                    value: currentValue,
                                                    index: this.mainIndex,
                                                    current: true,
                                                };
                                                this.mainIsEmpty = false;
                                            }

                                            typeof onSelect === 'function' &&
                                                onSelect(currentValue, list[currentIndex].index, obj);
                                        },
                                    );
                                }}
                            >
                                <span className="multi-lang-text-prefix">{value}</span>
                                <span className="multi-lang-text-suffix">{languageType}</span>
                            </li>
                        ))}
                    </ul>
                }
                dropdownStyle={styObj => { return { 'max-width': `${styObj.minWidth}px` }; }}
            >
                <NCHotKeys
                    className={`${disabled ? 'multiLangText-disabled ' : ''} multilang-hotkeys-wrapper base-multilang-wrapper`}
                    attach={false}
                    display="flex"
                    clearOpenPanel={false}
                    keyMap={{
                        hide: ['esc', 'enter'],
                        show: ['down'],
                        down: ['down'],
                        up: ['up'],
                        ctrl: { sequence: "ctrl", action: "keyup" },
                        // enter: ['enter'],
                    }}
                    handlers={{
                        hide: () => {
                            this.setState({ show: false });
                        },
                        // enter: e => {
                        //     // console.log(e);
                        //     this.props.onEnter && this.props.onEnter({ e });
                        // },
                        show: () => {
                            this.setState({ show: true });
                        },
                        down: e => {
                            let len = list.length;
                            let next = currentIndex + 1 >= len ? 0 : currentIndex + 1;
                            let value = list[next].value;
                            let { renderInTable, hotKeyWithArrow } = this.props;
                            let { show } = this.state;
                            if (renderInTable && !show && isArrowKeyDown(e)) {
                                hotKeyWithArrow && hotKeyWithArrow({ e });
                                return;
                            }
                            if (list[currentIndex].key == attrcode) {
                                this.mainIsEmpty = false;
                            }
                            this.firstFlag = false;
                            this.setState(
                                {
                                    currentIndex: next,
                                    currentValue: value,
                                },
                                () => {
                                    let obj = {};
                                    let loginIndex;
                                    list.forEach((e, i) => {
                                        if (e.languageCode == localeLang) {
                                            // 当前编辑的是登录语言且主语言没值
                                            loginIndex = i;
                                        }

                                        obj[e.key] = {
                                            value: e.value,
                                            index: e.index,
                                            current: currentIndex == i,
                                        };
                                    });

                                    if (currentIndex == loginIndex && this.mainIsEmpty) {
                                        // 当前编辑的是登录语言且主语言没值
                                        obj[this.mainKey] = {
                                            value: currentValue,
                                            index: this.mainIndex,
                                            current: true,
                                        };
                                    }
                                    typeof onSelect === 'function' && onSelect(value, list[next].index, obj);
                                },
                            );
                        },
                        up: e => {
                            let len = list.length - 1;
                            let next = currentIndex - 1 < 0 ? len : currentIndex - 1;
                            let value = list[next].value;
                            let { renderInTable, hotKeyWithArrow } = this.props;
                            let { show } = this.state;
                            if (renderInTable && !show && isArrowKeyDown(e)) {
                                hotKeyWithArrow && hotKeyWithArrow({ e });
                                return;
                            }
                            if (list[currentIndex].key == attrcode) {
                                this.mainIsEmpty = false;
                            }
                            this.firstFlag = false;
                            this.setState(
                                {
                                    currentIndex: next,
                                    currentValue: value,
                                },
                                () => {
                                    typeof onSelect === 'function' && onSelect(value, list[next].index);
                                },
                            );
                        },
                        ctrl: e => {
                            this.setState({ show: !this.state.show });
                        },
                    }}
                >
                    <div
                        className={multiLangClass}
                        ref={dom => {
                            this.multiLangText = dom;
                        }}
                        fieldid={fieldid || null}
                        onKeyDown={e => {
                            if (e.keyCode == 13) {
                                this.props.onEnter && this.props.onEnter({ e });
                            }
                        }}
                    >
                        <NCFormControl
                            itemtype="residtxt"
                            type="text"
                            value={currentValue}
                            className={className}
                            id={id}
                            onChange={(v, e, chineseEntering) => {
                                let _v = v;
                                // _v = _v.replace(/[^\x00-\xff]/g, '11');
                                currentValue = v;
                                list[currentIndex].value = currentValue;
                                if (_v.length > Number(max_l) && !e.target.isFlag && !chineseEntering) {
                                    currentValue = currentValue.slice(0, max_l);
                                    list[currentIndex].value = currentValue;
                                }
                                let obj = {};
                                let loginIndex;
                                list.forEach((e, i) => {
                                    if (e.languageCode == localeLang) {
                                        // 当前编辑的是登录语言且主语言没值
                                        loginIndex = i;
                                    }

                                    obj[e.key] = {
                                        value: e.value,
                                        index: e.index,
                                        current: currentIndex == i,
                                    };
                                });

                                if (currentIndex == loginIndex && this.mainIsEmpty) {
                                    // 当前编辑的是登录语言且主语言没值
                                    obj[this.mainKey] = {
                                        value: currentValue,
                                        index: this.mainIndex,
                                        current: true,
                                    };
                                }

                                // this._currentValue = currentValue;
                                typeof onChange === 'function' && onChange(obj);
                                this.setState({
                                    currentValue,
                                    list,
                                });
                            }}
                            onFocus={evt => {
                                this.focused = true;

                                // 登陆语言的值赋给主语言
                                let main = list.find(e => e.key === this.mainKey);
                                if (main && main.value) {
                                    this.mainIsEmpty = false;
                                } else {
                                    this.mainIsEmpty = true;
                                }

                                let { renderInTable } = this.props;
                                !renderInTable && this.setState(
                                    { show: true },
                                    () => {
                                        // onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                                    },
                                );
                                onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                            }}
                            onBlur={() => {
                                let invalid = false;
                                Object.entries(value).map(([k, v]) => {
                                    let correct = this.validate(v?.value);
                                    if (!correct) {
                                        invalid = true;
                                        value[k] = { value: '', current: true };
                                    }
                                });

                                if (invalid) {
                                    toast({
                                        mark: 'input-reg-tip',
                                        color: 'danger',
                                        title: json['base-maxlength-check-title'],
                                        content: regMessage || json['base-reg-check-content'],
                                        container: toastContainer,
                                    });

                                    typeof onChange === 'function' && onChange(value);
                                    typeof onBlur === 'function' && onBlur(value);
                                } else {
                                    this.close();
                                }
                            }}
                            autocomplete='off'
                            hotKeyWithArrow={hotKeyWithArrow}
                            disabled={disabled}
                            placeholder={placeholder}
                            autoFocus={autoFocus}
                            onClick={evt => {
                                let { renderInTable } = this.props;
                                if (renderInTable) {
                                    this.setState({ show: true });
                                    onFocus && onFocus(evt, evt.target, list[currentIndex].key);
                                }
                            }}
                            showClose={true}
                            maxlength={maxlength}
                            isCheckChinese={!!maxlength}
                            toastContainer={toastContainer}
                        />
                        <span className="multi-lang-suffix">
                            {list[currentIndex] && list[currentIndex].languageType}
                        </span>
                    </div>
                    {afterContent && typeof afterContent === 'function' && afterContent(list, currentIndex)}
                </NCHotKeys>
            </Dropdown>
        );
    }

    validate = value => {
        let {
            reg,
            verifyClear = true,
        } = this.props;

        if (value && reg && verifyClear) {
            let result = false;
            // 复杂的身份证校验，正则搞不定，传进来一个function
            if (Object.prototype.toString.call(reg) === '[object Function]') {
                result = reg(value);
            }
            // 普通的正则校验
            if (Object.prototype.toString.call(reg) === '[object RegExp]') {
                result = reg.test(value);
            }
            return result;
        }

        return true;
    }
}

MultiLangText.MultiOption = MultiOption;

//MultiLangText.defaultProps = { container: document.body };
